export default __webpack_public_path__ + "static/media/calculator.42dcb40c.png";